import React from "react";
import "./ScrollToTop.scss";
import Icon from "../../Elements/Icon/Icon.tsx";
import useScrollTrigger from "../../../hooks/useScrollTrigger.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";

const ScrollToTop = ({ children: any }) => {
  const { moreThanNumber } = useScrollTrigger(500);
  const { mobileCondition } = useMediaQueries();
  const handleClick = () => {
    window.scrollTo(0, 0);
  };
  return (
    <AnimationContainer
      animationOn={moreThanNumber && !mobileCondition}
      animationClassName="fade-in"
    >
      <div className="scroll-to-top-button-container">
        <Icon onClick={handleClick} blue name="arrow-up"></Icon>
      </div>
    </AnimationContainer>
  );
};

export default ScrollToTop;
